import {
	DATA_SUMMARY_WITH_ERRORS_MODAL_I18N_KEYS
} from '../../../../../features/topics/components/constants/i18n/DataSummaryWithErrorsModali18nConstants';

export const DATA_SUMMARY_WITH_ERRORS_MODAL_I18N_EN = {
	[DATA_SUMMARY_WITH_ERRORS_MODAL_I18N_KEYS.modal_title]:                     "Data Summary",
	[DATA_SUMMARY_WITH_ERRORS_MODAL_I18N_KEYS.select_another_file_button_text]: "Select another file",
	[DATA_SUMMARY_WITH_ERRORS_MODAL_I18N_KEYS.remove_rows_with_errors_and_proceed_button_text]: "Remove rows with errors and proceed"
};


// WEBPACK FOOTER //
// ./src/locales/en/features/topics/components/data_summary_with_errors_modal.i18n.en.js